import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getAjiogramDesktopRedirectBanner } from '../../../refresh/selectors/featureFlagsSelector';
import properties from '../../../modules/ajio-util/properties';
import { replaceWithJioCDN } from '../../../utils/imageHandling';


class StoreRedirectBanner extends Component {
    constructor(props) {
        super(props);
      }

    clickHandler = () => {
        let redirectionUrl = properties.getProperty('parentUrl');
        return window.location.href = redirectionUrl;
    };

    render() {
        return (
        <div className='store-redirect-container' onClick={this.clickHandler}>
            <img src={replaceWithJioCDN(this.props.ajiogramRedirectBanner?.image)}
                 alt={this.props.ajiogramRedirectBanner?.altText}
            />
        </div>
        )
    }
};

const mapStateToProps = (state) => {
    const ajiogramRedirectBanner = getAjiogramDesktopRedirectBanner(state.flags);
    return {
        ajiogramRedirectBanner
    }
};

export default connect(mapStateToProps)(StoreRedirectBanner);
